<template>
    <div style="padding: 30px">
        <div class="container">
            <div class="row">
                <div class="col-12 mb-4">
                    <a v-if="cases.length>0" :href="excelLink" class="btn btn-success">Descargar casos <i class="fa fa-file-excel"></i></a>
                </div>
                <div class="table-responsive col-12">
                    <table class="table table-bordered table-sm" style="width: 100%" id="cases-table">
                        <thead>
                            <tr>
                                <th scope="col">Número de caso</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Organización</th>
                                <th scope="col">Solicitante</th>
                                <th v-if="user.type=='admin'" scope="col">Dependencia</th>
                                <th scope="col">Estado</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                    	<tbody>
                            <case-item @goToCase="clearTimer" class="case-component" v-for="userCase in cases" v-bind:key="userCase.id" :userCase="userCase"/>
                    	</tbody>
                    </table>   
                </div>        
            </div>
        </div>
    </div>
</template>
<script>
import CaseItem from '@/components/CaseComponent.vue';
import { setTimeout } from 'timers';
export default {
    name: 'cases',
    components: {CaseItem},
    mounted: function(){
        var casesTable = $("#cases-table");
        casesTable.css("display", "none");

        this.timeOut = window.setTimeout(()=>{window.location.reload()}, 60000 * 12);
    },
    created: function(){
        var token = localStorage.getItem('session_id');
        if(!token){
            this.$router.push('/');
        } else {
            this.fetchCases();
        }
    },
    data() {
        return {
            cases: [],
            user: JSON.parse(localStorage.getItem('user')),
            timeOut: null
        }
    },
    computed: {
        excelLink: function(){
            let token = localStorage.getItem("session_id");
            return `${process.env.VUE_APP_API}/${this.user.type}/cases-exports?token=${token}`;
        }
    },
    methods: {
        fetchCases: function(){
            let loader = this.$loading.show();
            this.$http.get(
                `${process.env.VUE_APP_API}/${this.user.type}/cases`,
                {
                    headers: 
                    {
                        Authorization: `Bearer ${localStorage.getItem('session_id')}`
                    }
                }
            )
            .then(data => {
                this.cases = data.body.data;
                loader.hide();
                setTimeout(this.renderTable, 100);
            })
        }, renderTable(){
            var casesTable = $("#cases-table");

            casesTable.DataTable({
            "order": [[0, "desc"]],
            "language": {
                "sProcessing":     "Procesando...",
                "sLengthMenu":     "Mostrar _MENU_ registros",
                "sZeroRecords":    "No se encontraron resultados",
                "sEmptyTable":     "Ningún dato disponible en esta tabla",
                "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                "sInfoPostFix":    "",
                "sSearch":         "Buscar:",
                "sUrl":            "",
                "sInfoThousands":  ",",
                "sLoadingRecords": "Cargando...",
                "oPaginate": {
                    "sFirst":    "Primero",
                    "sLast":     "Último",
                    "sNext":     "Siguiente",
                    "sPrevious": "Anterior"
                },
                "oAria": {
                    "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                    "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                }
            }
        });
            this.dataTable = true;
            casesTable.css("display", "table");
        }, clearTimer(){
            console.log(this.timeOut);
            clearTimeout(this.timeOut);
            console.log("timer cleared");
            console.log(this.timeOut);
        }
    }
}
</script>




